<script>
export default {
  name: 'InfoAlert',
  props: {
    color: { type: String, default: 'default' },
    icon: { type: String, default: 'mdi-information' },
    message: { type: String, required: true }
  }
}
</script>

<template>
  <v-alert :color="color" :icon="false" variant="tonal">
    <div class="d-flex flex-column align-center justify-center ga-3 text-center w-100">
      <v-icon :icon="icon" size="38" />
      <span class="info-alert-message">{{ message }}</span>
    </div>
  </v-alert>
</template>

<style scoped>
.info-alert-message {
  width: 100%;
  white-space: pre-line;
  text-align: center;
}
</style>
